import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { IDocumentsModulesResponse } from "./documents.constants";

@Injectable({
    providedIn: 'root'
})
export class DocumentsService {

    constructor(
        private _httpClient: HttpClient
    ) { }

    get isLocalEnv(): boolean {
        return environment.name === 'LOCAL' || environment.name === 'LOCAL_BE';
    }

    retrieveDocuments(): Observable<IDocumentsModulesResponse> {
        const url = environment.apiBaseUrl + environment.apiPaths.downloadModules;
        return this._httpClient.get<IDocumentsModulesResponse>(url);
    }

    downloadDocument(downloadUrl: string): Observable<Blob> {
        if (this.isLocalEnv) {
          return of(new Blob(['Testo di prova'], { type: 'text/plain' }));
        }
        const headers = new HttpHeaders()
          .set('skipAuthorization', 'true');
        return this._httpClient.get<Blob>(downloadUrl, {
          withCredentials: false,
          headers: headers,
          responseType: 'blob' as 'json'
        });
    }
}
